import axios from "axios";
import { getBaseUrl } from "../utils/Helpers";

const BASE_URL = getBaseUrl()

const baseAxiosInstance = axios.create({
  baseURL: BASE_URL,
  timeout: 60000,
  headers: {
    "Content-Type": "application/json;charset=utf-8",
    // "Cache-Control": "no-cache",
  },
  withCredentials: true,
});

baseAxiosInstance.interceptors.request.use(
  (config) => {
    const accessToken = localStorage.getItem("accessToken");
    if (accessToken) {
      config.headers["Authorization"] = `Bearer ${accessToken}`;
    }
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

let isRefreshing = false;
let refreshSubscribers = [];
let isLoggingOut = false;

const subscribeTokenRefresh = (cb) => {
  refreshSubscribers.push(cb);
};

const onRefreshed = (token) => {
  refreshSubscribers.map((cb) => cb(token));
};

const logout = () => {
  if (!isLoggingOut) {
    isLoggingOut = true;
    localStorage.removeItem("accessToken");
    window.location.href = "/";
    // window.location.reload();
  }
};

const refreshToken = async () => {
  try {
    const response = await axios.post(`${BASE_URL}/refresh`, {}, { withCredentials: true });
    const accessToken = response?.data?.result?.accessToken;
    if (!accessToken) {
      logout();
      return;
    }
    localStorage.setItem("accessToken", accessToken);
    onRefreshed(accessToken);
    refreshSubscribers = [];
    return accessToken;
  } catch (error) {
    logout();
    return Promise.reject(error);
  }
};

baseAxiosInstance.interceptors.response.use(
  async (response) => {
    // console.log("axios response", response);

    // Check if the response indicates an invalid token
    const messages = ["Invalid Token", "Access Denied"];
    if (response.data.status === "Failure" && messages.includes(response.data.message)) {
      if (!isRefreshing) {
        isRefreshing = true;
        try {
          const newToken = await refreshToken();
          isRefreshing = false;
          response.config.headers["Authorization"] = `Bearer ${newToken}`;
          return baseAxiosInstance(response.config);
        } catch (err) {
          return Promise.reject(err);
        }
      }

      const retryOriginalRequest = new Promise((resolve) => {
        subscribeTokenRefresh((token) => {
          response.config.headers["Authorization"] = `Bearer ${token}`;
          resolve(baseAxiosInstance(response.config));
        });
      });
      return retryOriginalRequest;
    }

    return response;
  },
  (error) => {
    console.log("axios error", error);
    return Promise.reject(error);
  }
);

export default baseAxiosInstance;
